module.exports = __webpack_public_path__ + "assets/img/55.e9b357b2.png";